export const CCtaContactFragment = `
  fragment ctaContact on ctaContact_MatrixField {
    ... on ctaContact_block_Entry {
      heading
      subHeading
      ctas {
        ... on ctas_Entry {
          cta {
            type
            url
            text
            target
          }
        }
      }
    }
  }
`
